import {
    StandardDateFormat,
    formatCalendarDate,
    formatDatetimeTooltip,
    formatStandardDateString,
    formatStandardDatetimeString,
} from "@utils/formatDate"

import useUser from "./useUser"

// The standard date formatters bound to the service company's preferred timezone. Until the user
// has loaded there is no company timezone, and dayjs falls back to the browser's.
export default function useDateFormatters() {
    const { user } = useUser()

    const preferredTimezone = user?.service_company?.preferred_timezone

    return {
        formatDate: (date: string | Date | null | undefined, format?: StandardDateFormat): string | null =>
            formatStandardDateString(date, preferredTimezone, format),
        formatDatetime: (date: string | Date | null | undefined, format?: StandardDateFormat): string | null =>
            formatStandardDatetimeString(date, preferredTimezone, format),
        formatDatetimeTooltip: (label: string, date: string | Date | null | undefined, isFuture?: boolean): string =>
            formatDatetimeTooltip(label, date, preferredTimezone, isFuture),
        formatCalendarDate: (date: string | Date): { month: string; day: string } =>
            formatCalendarDate(date, preferredTimezone),
    }
}
